import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const ProcessSecOne = ({ className = '' }) => {
  const listRef = useRef(null);
  const { t } = useTranslation();
  const processes = t('sections.processSecOne.processes', { returnObjects: true, defaultValue: [
    {
      num: '01',
      title: 'Comprehensive Assessment',
      text: 'Evaluate the severity of threats, their potential impact on your business, and the likelihood of occurrence.Ensure adherence to industry standards and regulations, such as GDPR, HIPAA, and PCI DSS.',
      themeColor: '#069845',
      bgColor: '#011E1D'
    },
    {
      num: '02',
      title: 'Advanced Threat Detection',
      text: 'Detect and prevent sophisticated cyberattacks. Data Encryption: Safeguard sensitive information with strong encryption.Protect web applications from attacks.Monitor network traffic .',
      themeColor: '#F0A230',
      bgColor: '#24201A'
    },
    {
      num: '03',
      title: 'Incident Response',
      text: 'When a threat is detected, our automated response systems spring into action. We swiftly contain the incident, minimize damage, and restore your systems to normal operation. Our expert security analysts monitor.',
      themeColor: '#E0009B',
      bgColor: '#22082A'
    },
    {
      num: '04',
      title: 'Continuous Monitoring',
      text: 'We maintain 24/7 vigilance over your cloud environment, ensuring ongoing protection. Our security systems are constantly learning and adapting to the ever-evolving threat landscape. We proactively identify.',
      themeColor: '#8F54FF',
      bgColor: '#151439'
    }
  ] });

  useEffect(() => {
    const listItems = listRef.current?.querySelectorAll('li');
    
    if (!listItems) return;

    const handleMouseEnter = function() {
      const currentIndex = Array.from(listItems).indexOf(this);
      
      // Add dot-active class to current and all previous siblings
      listItems.forEach((item, index) => {
        if (index <= currentIndex) {
          item.classList.add('dot-active');
        }
      });
    };

    const handleMouseLeave = function() {
      // Remove dot-active class from all items
      listItems.forEach(item => {
        item.classList.remove('dot-active');
      });
    };

    // Add event listeners to each list item
    listItems.forEach(item => {
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    });

    // Cleanup
    return () => {
      listItems.forEach(item => {
        item.removeEventListener('mouseenter', handleMouseEnter);
        item.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <div className={` ${className}`}>
      <div className="shape-mockup bg-gradient-shape1 why-bg-gradient1" data-top="auto" data-bottom="30%" data-right="0" data-left="auto"></div>
      <div className="shape-mockup bg-gradient-shape1 why-bg-gradient2" data-top="20%" data-left="3%"></div>
      <div className="container">
        <div className="title-area mb-40 text-center">
          <span className="sub-title style2" data-cue="slideInUp">{t('sections.processSecOne.sub_title','How it Works')}</span>
          <h2 className="sec-title" data-cue="slideInUp" data-delay="100" dangerouslySetInnerHTML={{ __html: t('sections.processSecOne.title','Securing Your Digital Future, <br /> Step by Step') }} />
        </div>
        <div className="row">
          <div className="col-12">
            <ul className="work-process-list" ref={listRef}>
              {processes.map((process, index) => (
                <li className="work-process-single-list" data-cue="slideInUp" key={index}>
                  <div className="single-work-process">
                    <div className="box-number" data-theme-color={process.themeColor}>
                      <span className="box-number-bg" data-theme-color={process.bgColor}></span>
                      {process.num}
                    </div>
                    <div className="box-content">
                      <h4 className="box-title">{process.title}</h4>
                      <p className="box-text">{process.text}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSecOne;